import React from 'react';
import entries from './entries';
import './MenaGallery.css';

const MenaGallery2024_2025 = () => {
    return (
        <div className="mena-gallery-container">
            <div className="mena-gallery-grid">
                {entries.map((entry, index) => {
                    const safeTeam = entry.team.replace(/[^\w-]/g, '_');
                    const thumbFile = `${safeTeam}_${index.toString().padStart(3, '0')}.png`;
                    const thumbPath = `/thumbnails/${thumbFile}`;

                    return (
                        <div className="mena-gallery-card" key={`${entry.team}_${index}`}>
                            <a href={entry.url} target="_blank" rel="noopener noreferrer">
                                <img src={thumbPath} alt={`Screenshot for ${entry.team}`} className="mena-gallery-thumb" />
                            </a>
                            <div className="mena-gallery-label">{entry.team}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MenaGallery2024_2025;